import { render, staticRenderFns } from "./service-task-overview-card.vue?vue&type=template&id=cbd6bce2&scoped=true"
import script from "./service-task-overview-card.vue?vue&type=script&lang=js"
export * from "./service-task-overview-card.vue?vue&type=script&lang=js"
import style0 from "./service-task-overview-card.vue?vue&type=style&index=0&id=cbd6bce2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd6bce2",
  null
  
)

export default component.exports